import React from 'react';
import { useNavigate } from 'react-router-dom';
import HostInstructions from './HostInstructions';
import './Guide.css';

const HostGuide = () => {
  const navigate = useNavigate();

  return (
    <div className="guide-page">
      <div className="guide-header">
        <button 
          className="back-button"
          onClick={() => navigate('/')}
        >
          ← Back to Role Selection
        </button>
        <div className="guide-title-section">
          <h1>🎙️ Host Guide</h1>
          <p>Complete guide for hosting real-time translation sessions</p>
        </div>
        <div className="guide-actions">
          <button 
            className="start-button"
            onClick={() => navigate('/host')}
          >
            Start Hosting →
          </button>
        </div>
      </div>
      
      <div className="guide-content">
        <HostInstructions />
      </div>
    </div>
  );
};

export default HostGuide;